import React from 'react';
import styled from 'styled-components';



const Location = styled.div`
    color: ${ props => props.inverted ? props.inverted : '#fff'};
    margin: 0px;
    padding: 0px;
    letter-spacing: 1.2px;
    align-items: center;
    & i {
        top: 0px;
        font-size: 14px;
        color: ${ props => props.inverted ? props.inverted : '#fff'};
        margin: 0px;
        padding: 0px !important;
    }
    & p{
        font-size: ${ props => props.fontSize ? props.fontSize : '10px'};
    }
    @media(max-width: 768px){
        color: var(--secondary-color);
        & i {
            color: var(--secondary-color)
        }
    }
`



const PhotoLocation= ({location, inverted, fontSize})=>{

    return(
        <Location 
            inverted={inverted} 
            className='grid photo-location '
            fontSize={fontSize}
        >
            <i className='material-icons'>location_on</i>
            <p>{location ? location : 'Not available '}</p>
        </Location>
    )
}


export default PhotoLocation